import type { CitationToken } from './types';

const PMID_RE = /\[PMID:\s*([0-9]+)\]/gi;
const DOI_RE = /\[DOI:\s*([^\]\s]+)\]/gi;
const ARXIV_RE = /\[arXiv:\s*([^\]\s]+)\]/gi;

/**
 * Scan a string for citation tokens (`[PMID:x]`, `[DOI:x]`,
 * `[arXiv:x]`) and return them deduped, in order of first
 * appearance. Used by both the toolbar (to enrich custom-event
 * detail) and the selection router (when the toolbar hasn't
 * pre-scanned).
 */
export function extractCitationTokens(text: string): CitationToken[] {
  if (!text) return [];
  const seen = new Set<string>();
  const out: CitationToken[] = [];
  const push = (
    type: CitationToken['type'],
    identifier: string,
    raw: string
  ) => {
    const key = `${type}:${identifier.toLowerCase()}`;
    if (seen.has(key)) return;
    seen.add(key);
    out.push({ type, identifier, raw });
  };

  for (const m of text.matchAll(PMID_RE)) push('pubmed', m[1], m[0]);
  for (const m of text.matchAll(DOI_RE)) push('doi', m[1], m[0]);
  for (const m of text.matchAll(ARXIV_RE)) push('arxiv', m[1], m[0]);
  return out;
}
